import { Box, Button, Stack } from '@mui/material';

import Container from 'components/Container';
import CloudTitleBar from 'components/cloud/CloudTitleBar';
import { baseColors } from 'utils/constants';

type Props = {
  title?: React.ReactNode;
  onLogout: () => void;
};

const CloudHeaderBar = ({ title = 'マイページ', onLogout }: Props) => {
  return (
    <Container sx={{ pt: 2, px: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%', maxWidth: { md: 580 }, mx: 'auto' }}>
        <Box sx={{ mr: 'auto' }}>
          <CloudTitleBar sx={{ '& .MuiTypography-root': { color: baseColors.cloudOrange } }}>{title}</CloudTitleBar>
        </Box>
        <Button
          size="small"
          variant="outlined"
          onClick={onLogout}
          sx={{ borderColor: '#d4d4d4', color: '#333', height: 32, px: 2, borderRadius: 1.5, whiteSpace: 'nowrap' }}
        >
          ログアウト
        </Button>
      </Stack>
    </Container>
  );
};

export default CloudHeaderBar;
